<template>
	<div>
		<div v-if="authUserPermission['stock-calc-fast-by-demand']">
			<base-header class="pb-6">
				<div class="row align-items-center py-4">
					<div class="col-lg-6 col-7">
						<h6 class="h2 text-white d-inline-block mb-0"></h6>
					</div>
				</div>
			</base-header>
			<div class="container-fluid mt--6">
				<div class="card mb-4">
					<div class="card-header mt--4 mb--4">
						<div class="row">
							<div class="col-12">
								<h3>Search Material Lead Time</h3>
							</div>
						</div>
					</div>

					<div class="card-body">
						<div class="col-16 mt-3">
							<div class="d-flex flex-wrap align-items-start">
								<div class="mr-2" style="flex: 0 0 145px; min-width: 100px;">
									<label class="form-control-label">
										<b>Gunakan Data TA </b>
										<el-tooltip placement="top">
											<template #content> Pilihan Mengikutsertakan Data Demand <br> Turn Around
												pada Perhitungan </template>
											<sup>
												<span style="font-size:10px"><i
														class="fa fa-exclamation-circle"></i></span>
											</sup>
										</el-tooltip>
									</label>
									<base-input>
										<el-select v-model="dataTa" style="width: 100%; margin-top: 5px;"
											placeholder="Choose" disabled>
											<el-option label="Ya" value="true"></el-option>
											<el-option label="Tidak" value="false"></el-option>
										</el-select>
									</base-input>
								</div>
								<div class="mr-2" style="flex: 0 0 145px; min-width: 100px;">
									<label class="form-control-label">
										<b>Anak Perusahaan </b>
										<el-tooltip placement="top">
											<template #content> Anak Perusahaan dalam PI Group </template>
											<sup>
												<span style="font-size:10px">
													<i class="fa fa-exclamation-circle"></i>
												</span>
											</sup>
										</el-tooltip>
									</label>
									<base-input>
										<el-select v-model="dataFitting.plant" filterable
											style="width: 100%; margin-top: 5px;" placeholder="Pilih Plant"
											:disabled="['B000', 'C000', 'D000', 'E000', 'F000', 'G000', 'H000', 'I000', 'J000'].includes(authUser.company_code)"
											@change="changePlant">
											<el-option v-for="plant in plants" :key="plant.code" :value="plant.code"
												:label="`${plant.name}`"></el-option>
										</el-select>
									</base-input>
								</div>
								<div class="mr-2" style="flex: 0 0 170px; min-width: 250px;">
									<label class="form-control-label">
										<b>Material Number </b>
										<el-tooltip placement="top">
											<template #content>Material Spare Part MRO (6XXXXX)</template>
											<sup>
												<span style="font-size:10px">
													<i class="fa fa-exclamation-circle"></i>
												</span>
											</sup>
										</el-tooltip>
									</label>
									<base-input>
										<el-autocomplete v-model="searchQuery" style="width: 100%; margin-top: 5px;"
											:fetch-suggestions="fetchSuggestionsMasterMaterialNumber"
											placeholder="Search Material Number" :loading="loadingSearch"
											@select="handleSelectMaterialNumber" :trigger-on-focus="false">
											<template slot-scope="{ item }">
												<div :class="item.label === 'No Data' ? 'text-center' : ''">{{
													item.label }}</div>
											</template>
										</el-autocomplete>
									</base-input>
								</div>
								<div class="d-flex align-items-center"
									style="flex: 1; min-width: 200px; margin-top: 35px;">
									<base-button type="success" @click="handleFittingData"
										:disabled="isFittingDataDisabled" :loading="loadingFittingData">
										Search Material
									</base-button>

									<base-button type="danger" @click="resetParameter">
										Reset
										<el-tooltip placement="top">
											<template #content> Mereset ulang inputan </template>
											<sup>
												<span style="font-size:10px"><i class="fa fa-exclamation-circle"></i>
												</span>
											</sup>
										</el-tooltip>
									</base-button>

								</div>
							</div>


							<!-- Kolom untuk Unit Price, Initial Inventory, Metode ROQ, dan Order Cost dengan latar belakang abu-abu -->
							<div class="row mt-4" v-if="openTableDirekomendasikan">
								<div class="col-12">
									<div class="p-3" style="background-color: #e3e3e3">
										<div class="row">
											<div class="col-12">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Direkomendasikan metode <el-tooltip placement="top">
															<template #content> Rekomendasi metode untuk perhitungan
																<br> berdasarkan karakteristik data
															</template>
															<sup>
																<span style="font-size:10px">
																	<i class="fa fa-exclamation-circle"></i>
																</span>
															</sup>
														</el-tooltip></b>

													<span>&nbsp;{{ fittingDataResult.kategori }}</span>
												</label>
											</div>
										</div>
										<div class="row">
											<!-- Kolom Lead Time perhari -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time (Hari) </b>
													<el-tooltip placement="top" effect="dark">
														<template #content>
															Durasi waktu semenjak user (perencanaan pemeliharaan) <br>
															menginformasikan permintaan Spare Part <br> sampai dengan
															waktu kedatangannya (PR-GR).<br>
														</template>
														<sup>
															<span style="font-size:0.8vw;">
																<i class="fa fa-exclamation-circle"></i>
															</span>
														</sup>
													</el-tooltip>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="formattedLeadTimeDay" type="number"
													>
											</div>

											<!-- Kolom Lead Time perhari -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time (Bulan) </b>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="formattedLeadTime" type="number"
													>
											</div>
											
											<!-- Kolom Maksimum -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time Max (Hari)</b>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="maxLeadTimeDay" type="number"
													>
											</div>

											<!-- Kolom Minimum -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time Min (Hari)</b>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="minLeadTimeDay" type="number"
													>
											</div>
											<!-- Kolom avg -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time Rata-Rata (Hari)</b>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="formattedAvgLeadTimeDay" type="number"
													>
											</div>

											<!-- Kolom avg -->
											<div class="col-md-6 mb-3"
												v-if="['Poisson', 'Normal', 'Tak Tentu', 'Deterministik'].includes(fittingDataResult.kategori)">
												<label class="form-control-label" style="font-size:0.85vw;">
													<b>Lead Time Rata-Rata (Bulan)</b>
												</label>
												<input class="form-control" style="width: 100%;" placeholder="Lead Time"
													v-model.number="formattedAvgLeadTime" type="number"
													>
											</div>
											
										</div>
									</div>
								</div>
							</div>
							
							<skeleton-loading v-if="loadingFittingData" />
							<empty v-if="!openTableDirekomendasikan && !loadingFittingData"></empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<noaccess v-else />
	</div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import SkeletonLoading from '../../components/SkeletonLoading.vue';
import configUrl from '@/configs/config'

export default {
	name: 'MaterialLeadTime',
	components: { SkeletonLoading },
	data() {
		return {
			leadTime: 0,
			minLeadTime: 0,
			maxLeadTime: 0,
			minLeadTimeDay: 0,
			maxLeadTimeDay: 0,
			dataTa: 'true',
			serviceLevel: 90,
			dataFitting: {
				plant: null,
				materialNumber: null
			},
			searchQuery: '',
			selectedMaterialNumber: '',
			plants: [
				{ code: 'B601', name: 'PKG' },
				{ code: 'C601', name: 'PKC' },
				{ code: 'D601', name: 'PKT' },
				{ code: 'E601', name: 'PIM' },
				{ code: 'F601', name: 'PSP' },
				{ code: 'I601', name: 'PILOG' },
				{ code: 'J601', name: 'PIU' },
			],
			loadingFittingData: false,
			loadingSearch: false,
			fittingDataResult: {},
			apiUrl: configUrl.apiUrl,
			loadTimeoutFetchMatNum: null,
			openTableDirekomendasikan: false
		}

	},
	computed: {
		...mapState({
			authUserPermission: state => state.auth.userPermission,
			authUser: state => state.auth.user
		}),
		isFittingDataDisabled() {
			return !this.dataTa || !this.dataFitting.plant || !this.dataFitting.materialNumber || this.loadingFittingData;
		},
		formattedLeadTime: {
			get() {
				return Number(this.leadTime).toFixed(2);
			},
			set(value) {
				this.leadTime = Number(value);
			}
		},
		formattedLeadTimeDay() {
			return this.convertMonthToDaysAvg(Number(this.leadTime)).toFixed(2)
		},
		formattedAvgLeadTimeDay() {
			const avg_lead_time = (Number(this.minLeadTimeDay) + Number(this.maxLeadTimeDay)) / 2
			return avg_lead_time.toFixed(2)
		},
		formattedAvgLeadTime() {
			const avg_lead_time = (Number(this.minLeadTime.toFixed(2)) + Number(this.maxLeadTime.toFixed(2))) / 2
			return avg_lead_time.toFixed(2)
		},
	},
	mounted() {
		this.komponenTerpasang = 5;
		this.initializeSelectedPlant();
	},
	methods: {
		convertMonthToDaysAvg(month) {
			const numMonth = Number(month)
			if (!numMonth || isNaN(numMonth)) return 0
			const days = numMonth * 30
			return days
		},
		initializeSelectedPlant() {
			const mapping = {
				B000: 'B601',
				C000: 'C601',
				D000: 'D601',
				E000: 'E601',
				F000: 'F601',
				G000: 'G601',
				H000: 'H601',
				I000: 'I601',
				J000: 'J601',
			};

			// Cek apakah company_code ada dalam mapping
			if (this.authUser.company_code in mapping) {
				this.dataFitting.plant = mapping[this.authUser.company_code];
			}
		},
		async handleFittingData() {
			this.openTableDirekomendasikan 	= false
			this.loadingFittingData 		= true

			const postData = {
				"use_data_ta": this.dataTa === "true",
				"plant": this.dataFitting.plant,
				"material_codes": [String(this.selectedMaterialNumber)]
			};


			try {
				const response = await axios({ 
					method: 'POST', 
					url: 'https://stock-calc-be-v2.pupuk.in/fit-data', 
					headers: { "Content-Type": "application/json"}, 
					data: postData 
				});

				if (!response.data[0].deskripsi.includes('tidak ditemukan')) {
					this.fittingDataResult 	= response.data[0];
					this.leadTime 			= Number(this.fittingDataResult.lead_time ?? 0);
					this.minLeadTime 		= Number(this.fittingDataResult.lead_time_min ?? 0);
					this.maxLeadTime		= Number(this.fittingDataResult.lead_time_max ?? 0);
					this.minLeadTimeDay		= this.convertMonthToDaysAvg(this.minLeadTime.toFixed(2)).toFixed(2)
					this.maxLeadTimeDay		= this.convertMonthToDaysAvg(this.maxLeadTime.toFixed(2)).toFixed(2)

					if (['Normal', 'Poisson', 'Tak Tentu'].includes(this.fittingDataResult.kategori)) {
						this.serviceLevel = this.valueServiceLevel(this.dataFitting.plant)
					} else {
						this.serviceLevel = 0
					}

					if (this.fittingDataResult.kategori === 'Non Moving') {
						let getTotalQtyInstalled = await this.getEqpQtyInstalled()
						this.komponenTerpasang = this.fittingDataResult.kategori === 'Non Moving' && getTotalQtyInstalled !== 0 ? getTotalQtyInstalled : 5;
					}

					this.openTableDirekomendasikan = true
				} else {
					this.$notify({
						message: "Your Data material is not found.",
						type: 'danger',
						verticalAlign: "bottom",
						horizontalAlign: "left"
					});
				}
			} catch (error) {
				this.$notify({
					message: 'Error fetching fitting data: ' + error,
					type: 'danger',
					verticalAlign: "bottom",
					horizontalAlign: "left"
				});

				this.openTableDirekomendasikan = false
			} finally {
				this.loadingFittingData = false;
			}
		},
		fetchSuggestionsMasterMaterialNumber(queryString, cb) {
			if (!this.dataFitting.plant || queryString.length < 1) return cb([{ label: 'No Data' }]);
			const params = {
				plant: this.dataFitting.plant,
				material: queryString,
			};

			clearTimeout(this.loadTimeoutFetchMatNum);
			this.loadTimeoutFetchMatNum = setTimeout(async () => {
				this.loadingSearch = true;
				try {
					const response = await axios.get('https://stock-calc-be-v2.pupuk.in/master-material', { params });
					const results = response.data;

					if (results.length > 0) {
						cb(results.slice(0, 500).map(item => ({
							value: item.MATERIAL,
							label: `${item.MATERIAL} - ${item.DESCRIPTION}`,
							MATERIAL: item.MATERIAL,
							DESCRIPTION: item.DESCRIPTION,
						})));
					} else {
						cb([{ label: 'No Data' }])
					}
				} catch (error) {
					cb([]);
					this.$notify({
						message: error.message,
						type: "danger",
						verticalAlign: "bottom",
						horizontalAlign: "left"
					});
				} finally {
					this.loadingSearch = false;
				}
			}, 500);
		},
		handleSelectMaterialNumber(item) {
			this.searchQuery = item.label;
			this.selectedMaterialNumber = item.MATERIAL;
			this.dataFitting.materialNumber = item.MATERIAL;
		},
		changePlant() {
			this.searchQuery = '';
			this.selectedMaterialNumber = '';
			this.dataFitting.materialNumber = '';
		},
		valueServiceLevel(value) {
			const plantName = {
				'B601': 60,
				'C601': 80,
				'D601': 85,
				'E601': 90,
				'F601': 90,
				'I601': 90,
				'J601': 90
			}[value] || '';

			return plantName;
		},
		resetParameter() {
			this.dataFitting.materialNumber = null;
			this.fittingDataResult = {};
			this.leadTime = 0;
			this.komponenTerpasang = 5;
			this.serviceLevel = 90;
			this.searchQuery = '';
			this.selectedMaterialNumber = '';
			this.loadingFittingData = false;
			this.loadingSearch = false;
			this.openTableDirekomendasikan = false;
		},
		async getEqpQtyInstalled() {

			try {
				const url = this.apiUrl + 'get-equipment-quantity-installed'
				const response = await axios.get(url, { 
					params: {
						"material_number": String(this.selectedMaterialNumber),
						"plant": this.dataFitting.plant,
					}, 
					headers: { "Content-Type": "application/json" } 
				})

				return response.data.data
			} catch (error) {
				return error.response.data.data.length
			}
		},
	}
};
</script>

<style>
.el-tooltip__popper {
	font-size: 14px !important;
	max-width: 350px !important;
	word-break: break-word;
}

.customTableKecil tbody tr th,
td {
	padding: 6px !important;
	text-align: center;
}

.customTableInputKecil tbody tr td input {
	height: 30px !important;
	width: 100% !important;
	text-align: center;
}

/* sahrul */
.btn-yellow {
	background-color: rgb(252, 165, 3) !important;
	/* Warna latar belakang kuning */
	color: rgb(8, 7, 7) !important;
	/* Warna teks hitam */
	border-color: rgb(221, 201, 68) !important;
	/* Warna tepi kuning */
}

.btn-yellow:hover {
	background-color: darkorange !important;
	/* Warna latar belakang kuning tua saat dihover */
	border-color: darkorange !important;
	/* Warna tepi kuning tua saat dihover */
	color: rgb(239, 231, 231) !important;
	/* Warna teks hitam */
}

/* pop up matrix */
.table-container {
	overflow-x: auto;
	/* margin-bottom: 1rem; */
}

.matrix-table {
	width: 100%;
	border-collapse: collapse;
	text-align: center;
	font-size: 10px;
	/* Ukuran font lebih kecil */
	min-width: 600px;
	/* Lebar minimum lebih kecil */
}

.matrix-table th,
.matrix-table td {
	border: 1px solid #0d0909;
	/* Border lebih tipis */
	padding: 5px;
	/* Padding lebih kecil */
}

.matrix-table th {
	background-color: #2a4f8a;
	color: white;
	font-weight: bold;
	position: sticky;
	top: 0;
	z-index: 1;
}

.variable-header {
	background-color: #009688;
}

.method-header {
	background-color: #2196f3;
}

.sub-header {
	background-color: #64b5f6;
}

.bcr-header {
	background-color: #ffc107;
}

.matrix-table tbody td {
	background-color: #f9f9f9;
}

.matrix-table tbody tr:nth-child(even) td {
	background-color: #fff;
}

.table-header-center {
	text-align: center;
	font-weight: bold;
}

/* button fitting, reset matrix*/
.base-button {
	display: inline-flex;
	/* Tombol akan menyesuaikan dengan teks */
	align-items: center;
	/* Vertikal alignment teks */
	font-size: 0.647rem;
	/* Ukuran font default (misalnya, 14px) */
	padding: 12px 6px;
	/* Padding yang konsisten */
	border: none;
	/* Menghapus border default jika diperlukan */
	text-align: center;
	/* Menyelaraskan teks di tengah */
	margin: 0;
	/* Hapus margin */
	min-width: auto;
	/* Pastikan tombol tidak memiliki lebar minimum tetap */
	transform: scale(1);
	/* Pastikan transformasi tidak mempengaruhi ukuran */
}

.d-flex {
	display: flex;
	/* Menggunakan Flexbox untuk tata letak */
	align-items: center;
	/* Vertikal alignment konten */
	flex-wrap: wrap;
	/* Membungkus tombol jika ruang tidak cukup */
}

.base-button+.base-button {
	margin-left: 4px;
	/* Ruang antar tombol jika diperlukan */
}

.value-table-wrapped {
	word-wrap: break-word;
	word-break: break-word;
	overflow-wrap: break-word;
	white-space: normal;
}

.btn-swal-blue {
	background-color: #007BFF;
	/* Biru */
	color: #fff;
	border: none;
}

.btn-swal-blue:hover {
	background-color: #0056b3;
	/* Biru lebih gelap saat hover */
}

.btn-swal-red {
	background-color: #FF4136;
	/* Merah */
	color: #fff;
	border: none;
}

.btn-swal-red:hover {
	background-color: #cc3229;
	/* Merah lebih gelap saat hover */
}

/* Media query untuk ukuran font responsif jika diperlukan */
@media (max-width: 768px) {
	.base-button {
		font-size: 0.75rem;
		/* Ukuran font lebih kecil pada layar lebih kecil */
		padding: 4px 8px;
		/* Padding yang lebih kecil */
	}

	.matrix-table {
		font-size: 8px;
		/* Ukuran font lebih kecil pada layar kecil */
	}

	.matrix-table th,
	.matrix-table td {
		padding: 4px;
		/* Padding lebih kecil pada layar kecil */
	}

	.matrix-table th,
	.matrix-table td {
		white-space: nowrap;
		/* Mencegah teks membungkus pada ukuran kecil */
	}
}
</style>